export const c2cMock = {
  visible: true,
  component: 'new-flotante',
  taggingInfo: {
    componentName: 'ContactCircle',
    componentProduct: '',
    componentVariation: 'all',
  },
  flotanteProps: {
    iconId: 'Fijo',
    iconKind: 'M',
    iconSize: 19,
    iconColor: 'grey8',
    iconSegment: 'emp',
    labelColor: 'grey8',
    labelText: 'Te llamamos',
    desktopContainerTop: 418,
    mobileContainerTop: 256,
    desktopContainerBottom: 107,
    mobileContainerBottom: 75,
    backgroundColor: 'ambar',
    option: 'te-llamamos',
  },
};
